import { useSelector } from "react-redux";
import {
  convertToYYYYMM,
  convertToYYYYMMDD,
  parseDate,
} from "../utilities/filters";

export function processAccountTreso(accountTreso) {
  return accountTreso.flatMap((item) => {
    const { accountTresoId, status, type } = item;
    const types = type.split(",");

    return types.map((t) => {
      const trimmedType = t.trim();
      return trimmedType === "simulation"
        ? { accountTresoId, type: trimmedType }
        : { accountTresoId, status, type: trimmedType };
    });
  });
}

export function processAccountTresoFromObject(selectedAccountsObject) {
  const result = [];

  const processAccountStatuses = (statuses) => {
    return (
      statuses
        ?.filter((status) => !["simulation", "réel"].includes(status))
        .join(",") || ""
    );
  };

  const determineAccountType = (statuses) => {
    if (!statuses?.length) return "";

    const types = [];
    if (statuses.includes("réel")) types.push("réel");
    if (statuses.includes("simulation")) types.push("simulation");

    return types.join(",");
  };

  const createAccountEntry = (tresoId, statuses) => {
    const accountStatuses = processAccountStatuses(statuses);
    const accountType = determineAccountType(statuses);

    if (!accountStatuses && !accountType) return null;

    return {
      accountTresoId: tresoId,
      ...(accountStatuses && { status: accountStatuses }),
      ...(accountType && { type: accountType }),
    };
  };

  Object.entries(selectedAccountsObject).forEach(([tresoId, statuses]) => {
    const entry = createAccountEntry(tresoId, statuses);
    if (entry) result.push(entry);
  });

  return result;
}

export const transformFilterValues = (filters) => {
  const realFilters = filters.filter((item) => item.type === "réel");
  const simulationFilters = filters.filter(
    (item) => item.type === "simulation"
  );

  const combinedRealFilters =
    realFilters.length > 0
      ? {
          type: "réel",
          status: realFilters
            .map((item) => item.status)
            .filter(Boolean)
            .join(","),
        }
      : null;

  const result = [];
  if (combinedRealFilters) result.push(combinedRealFilters);
  result.push(...simulationFilters);

  return result;
};

export const useFiltersAndDates = () => {
  const { selectedMonths, mode, selectedMonthsSynthesis } = useSelector(
    (state) => state.layout
  );

  const {
    noFilterChecked,
    accountTreso,
    footerAccountTreso,
    noFilterCheckedCompta,
    footerComptaFilter,
    filterValuesCompta,
    showOnlyValidatedCompta,
  } = useSelector((state) => state.categories);
  const processedFilters = processAccountTreso(accountTreso);

  const transformedValues = transformFilterValues(filterValuesCompta);

  const constructFilters = () => {
    const isFiltersEmpty =
      mode === "compta" ? noFilterCheckedCompta : noFilterChecked;
    
    const filterOptionsForTable = mode === "compta" ? transformedValues : processedFilters;

    const tableConstructedFilters = {
      filterOptions: filterOptionsForTable,
      noFilterChecked: isFiltersEmpty,
      ...(mode === "compta" && showOnlyValidatedCompta
        ? { withAssignedPlanComptable: !showOnlyValidatedCompta }
        : {}),
    };

    let footerConstructedFilters;
    if (!isFiltersEmpty) {
      footerConstructedFilters = { filterOptions: filterOptionsForTable };
    } else if (mode === "compta") {
      footerConstructedFilters = footerComptaFilter;
    } else {
      footerConstructedFilters = footerAccountTreso;
    }

    return {
      footerConstructedFilters,
      tableConstructedFilters,
    };
  };

  const getStartAndEndDate = () => {
    const startDate = convertToYYYYMM(selectedMonths[0]);
    const endDate = convertToYYYYMM(selectedMonths[selectedMonths.length - 1]);

    return { startDate, endDate };
  };

  const getStartAndEndDateSynthesis = () => {
    const startDateSynthesis = convertToYYYYMM(selectedMonthsSynthesis[0]);
    const endDateSynthesis = convertToYYYYMM(
      selectedMonthsSynthesis[selectedMonthsSynthesis.length - 1]
    );

    return { startDateSynthesis, endDateSynthesis };
  };
  const getStartAndEndDateGraph = () => {
    const startDate = convertToYYYYMMDD(selectedMonths[0]);
    const endDate = convertToYYYYMMDD(
      selectedMonths[selectedMonths.length - 1],
      "lastDay"
    );

    return { startDate, endDate };
  };

  const getStartAndEndDateSideBar = () => {
    const start = selectedMonths?.map((month) => parseDate(month))[0];
    const end = selectedMonths?.map((month) => parseDate(month))[
      selectedMonths?.length - 1
    ];

    return { start, end };
  };
  return {
    constructFilters,
    getStartAndEndDate,
    getStartAndEndDateSynthesis,
    getStartAndEndDateGraph,
    getStartAndEndDateSideBar,
    noFilterChecked,
  };
};
